
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import CreateUUID from "../guid";
    import LabelOptional from "@/features/shared/components/LabelOptional.vue";

    @Component({
        components: {
            LabelOptional,
        },
    })
    export default class DropdownSearch extends Vue {
        @Prop({default: () => []})
        errorMessages!: string[];
        
        @Prop({ required: true })
        label!: string;

        @Prop({ type: Boolean, default: false })
        labelOptional!: boolean;

        @Prop({ required: true })
        options!: any[];

        @Prop({ default: () => CreateUUID() })
        id!: string;

        @Prop()
        value!: any; // Used for v-model support

        @Prop()
        optionValueKey!: string | null;

        @Prop({ default: "text" })
        itemLabel!: string;

        selectedOption: any = null;

        get selectedValue() {
            return this.getValueFromOption(this.selectedOption)
        }

        created() {
            this.selectedOption = this.getOptionByValue(this.value)

            this.$watch(
                () => this.selectedValue,
                value => this.$emit("input", value)) // Used for v-model support.

                this.$watch(
                () => this.options,
                _ => this.selectedOption = this.getOptionByValue(this.value));

                this.$watch(
                () => this.value,
                (newValue) => {
                    this.selectedOption = this.getOptionByValue(newValue);
                }
                );
        }
        
        getValueFromOption(option: any) {
            if (!option)
                return null;

            if (this.optionValueKey)
                return option[this.optionValueKey]
            else
                return option;
        }
        
        getOptionByValue(value: any) {
            return this.options.find(x => this.getValueFromOption(x) === value)
        }
    }
